import React, { createContext, useContext, useId, useState } from 'react';
import { FiChevronDown, FiInfo } from 'react-icons/fi';
import './warrantyHelp.scss';

export const WarrantyHelpLabel = createContext('Hướng dẫn');

export default function WarrantyHelp({ children, label, className = '' }) {
  const defaultLabel = useContext(WarrantyHelpLabel);
  const [open, setOpen] = useState(false);
  const id = useId();
  return <span className={`bw_warranty_help ${className}`}>
    <button type='button' className='bw_warranty_help_toggle' aria-expanded={open} aria-controls={id}
      onClick={event => { event.preventDefault(); event.stopPropagation(); setOpen(value => !value); }}>
      <FiInfo aria-hidden='true' /><span>{label || defaultLabel}</span><FiChevronDown aria-hidden='true' className={open ? 'is_open' : ''} />
    </button>
    <span id={id} hidden={!open} className='bw_warranty_help_content'>{children}</span>
  </span>;
}
